import { createSlice } from '@reduxjs/toolkit';
import {
    fetchWasteCodes
}  from '../actions/wasteCode';

export const wasteCodeSlice = createSlice({
    name: 'wasteCodes',
    initialState: {
        loading: false,
        data: [],
        current: null
    },
    reducers: {

    },
    extraReducers:(builder) => {
        builder
        // FETCH Waste codes
        .addCase(fetchWasteCodes.pending,(state) => { state.loading = true })
        .addCase(fetchWasteCodes.fulfilled,(state, action) => { 
            state.loading = false;
            state.data = action.payload
        })
        .addCase(fetchWasteCodes.rejected, (state) => { state.loading = false  })
    }
});

export default wasteCodeSlice.reducer; 
